<div class="twc-m-2">
    <h1 class="twc-h1">{{ 'WIZARD.TAB_UPLOAD_DATA' | translate }}</h1>

    <div class="twc-mt-1 twc-mb-3" *ngIf="subtitle">{{subtitle | translate}}</div>

    <div class="twc-row twc-col-12" *ngIf="!uploadWizardService.selectInitialJob">
        <p class="twc-body">{{ inputDataNoticeLabel | translate}}</p>
    </div>

    <div class="twc-row-center twc-mt-4">
        <div class="twc-col-md-4" *ngIf="!uploadWizardService.selectInitialJob">
            <div class="twc-form-control">
                <label class="twc-form-label">
                    <strong>{{ inputDataDropdownLabel | translate}}</strong>
                </label>
                <twc-select #formatSelect [placeholder]="inputDataDropdownNotSelectedLabel | translate"
                    [(ngModel)]="uploadWizardService.formatSelection" (ngModelChange)="onChangeFormatSelected($event)"
                    [disabled]="isLoading">
                    <twc-select-option *ngIf="!uploadWizardService.isImportStation" [value]="'None'">
                        <em>{{ inputDataDropdownNotSelectedLabel | translate}}</em>
                    </twc-select-option>
                    <twc-select-option *ngFor="let formatOption of formatDefinitions | async" [value]="formatOption">
                        {{ 'UPLOAD.FORMAT_' + formatOption.label | translate}}
                    </twc-select-option>
                </twc-select>
            </div>
        </div>
        <div class="twc-col-md-8" *ngIf="formatNotFound">
            <div class="twc-message-box twc-message-box-warning">
                {{'UPLOAD.FORMAT_NOT_DETECTED' | translate}}
            </div>
        </div>


        <div class="twc-col-md-8" *ngIf="errorLayerFilesNotValid">
            <div class="twc-message-box twc-message-box-warning">
                {{'UPLOAD.ADD_MORE_FILES' | translate}}
            </div>
        </div>
    </div>

    <div class="twc-row twc-mt-4" *ngIf="uploadWizardService.formatSelection?.label">
        <div class="twc-col-12">
            <span class="twc-body">{{formatNoticeString | translate}}</span>
        </div>
    </div>

    <!-- Warnings -->
    <ng-container *ngIf="uploadWizardService.formatSelection?.warnings">
        <div class="twc-row twc-mt-1" *ngFor="let warning of uploadWizardService.formatSelection?.warnings">
            <div class="twc-col-12">
                <div class="twc-message-box twc-message-box-info">
                    {{'UPLOAD.WARNING_' + warning | translate}}
                </div>
            </div>
        </div>
    </ng-container>

    <div class="precision-warning-span twc-row twc-mt-1" *ngIf="isImageFormatSelected()">
        <div class="twc-col-12">
            <span>{{'UPLOAD.INPUT_PRECISION_WARNING' | translate}}</span>
        </div>
    </div>

    <!-- file-box -->
    <div class="twc-row twc-mt-4">
        <div class="twc-col-12">
            <cw-input-file [addMethod]="'accumulate'" [maxFiles]="900" (openExternalDialog)="openExternalDialog()"
                [isLoading]="isLoading" [isAutoOpenEnabled]="isAutoOpenEnabled" [dialogMode]="getDialogMode()"
                [availableSize]="uploadWizardService.getAvailableSize()" [accept]="acceptedFiles"
                [files]="uploadWizardService.files" (added)="onAddFile()">
            </cw-input-file>
        </div>
    </div>

    <div *ngIf="uploadWizardService.pathError" class="path-error twc-message-box twc-message-box-error">
        <div>
            <div><strong>{{ 'UPLOAD.ERROR_INVALID_DATA_PATH' | translate }}</strong></div>
            <div>{{ uploadWizardService.pathError }}</div>
        </div>
        <twc-icon shape="delete" [size]="24" (click)="onRemoveError()"></twc-icon>
    </div>

    <div class="twc-row twc-mt-4">
        <div class="twc-form-control twc-col-lg-6 twc-col-md-12" *ngIf="isVisibleCRS">
            <label for="projection" class="twc-form-label font-bold">{{ 'CREATE_PROJECT.COORDINATE' | translate
                }}</label>
            <div class="twc-form-element">
                <cw-crs-search placeholder="{{'CREATE_PROJECT.PLACEHOLDER_COORDINATE' | translate}}" type="crs"
                    [selectItem]="uploadWizardService.crsValue"></cw-crs-search>
            </div>
        </div>
    </div>
</div>